export const ID = ['id'];
export const OBJECT_TYPE = ['objectType'];
export const OBJECT_ID = ['objectId'];
export const OBJECT_NAME = ['objectName'];
export const UPDATE = ['crmObjectUpdate'];
export const TIMESTAMP = ['timestamp'];
export const SOURCE = ['source'];
export const SOURCE_ID = ['sourceId'];
export const UPDATE_TYPE = ['@type'];
export const PIPELINE_ID = ['pipelineId'];
export const PIPELINE_NAME = ['pipelineName'];
export const PIPELINE_STAGE_ID = ['pipelineStageId'];
export const PIPELINE_STAGE = ['pipelineStage'];
export const CRM_CREATION_SOURCE = ['crmObjectUpdate', 'crmCreationSource'];
export const FORM_NAME = ['crmObjectUpdate', 'crmCreationSource', 'name'];
export const FORM_ID = ['crmObjectUpdate', 'crmCreationSource', 'connectedObjectSourceId'];